import { UnknownAction } from '@reduxjs/toolkit';
import { INITIATE_APPLICATION_SETTINGS } from '../actions/actionTypes';

interface ApplicationState {
  settings: any;
}

const initialState = {
  settings: {}
};

export function applicationReducer(state: ApplicationState = initialState, action: UnknownAction): ApplicationState {
  switch (action.type) {
    case INITIATE_APPLICATION_SETTINGS: {
      return {
        settings: action.payload
      }
    }

    default:
      return state
  }
}